/* Authored DE/EN theme copy and static Shopify locale labels. No machine translation. */
window.rs2UITranslations = {
  "pairs": [
    [
      "Mehr über uns",
      "More about us"
    ],
    [
      "Große Abenteuer.",
      "Big adventures."
    ],
    [
      "Eine kleine Pause. Noch ein Versuch. Entdecke unsere Spiele und erfahre, was als Nächstes kommt.",
      "A little break. One more try. Discover our games and find out what's next."
    ],
    [
      "Spiele entdecken",
      "Explore games"
    ],
    [
      "Games-Updates erhalten",
      "Get game updates"
    ],
    [
      "Zu unseren Spielen",
      "Explore our games"
    ],
    [
      "Bereit für eine Runde?",
      "Ready for a round?"
    ],
    [
      "Deine nächste Spielpause.",
      "Your next play break."
    ],
    [
      "Direkt im Browser",
      "Right in your browser"
    ],
    [
      "Das nächste Level lädt.",
      "The next level is loading."
    ],
    [
      "Neue Spiele sind in Arbeit. Melde dich an und erfahre von neuen Einblicken, Spieltests und Releases.",
      "New games are in the works. Sign up for new previews, playtests, and releases."
    ],
    [
      "Sei beim nächsten Level dabei.",
      "Join us for the next level."
    ],
    [
      "Danke! Deine Anmeldung ist angekommen. Falls du eine Bestätigungsmail erhältst, bestätige bitte deine E-Mail-Adresse.",
      "Thanks! Your signup has been received. If you receive a confirmation email, please confirm your email address."
    ],
    [
      "Deine E-Mail-Adresse",
      "Your email address"
    ],
    [
      "Ja, ich möchte Games-Updates per E-Mail erhalten. Jederzeit abbestellbar.",
      "Yes, I'd like game updates by email. Unsubscribe anytime."
    ],
    [
      "Für Games-Updates anmelden",
      "Sign up for game updates"
    ],
    [
      "BIS ZUR NÄCHSTEN RUNDE",
      "SEE YOU NEXT ROUND"
    ],
    [
      "Unsere Pixel-Freunde kennenlernen",
      "Meet our pixel friends"
    ],
    [
      "Sag Hallo!",
      "Say hello!"
    ],
    [
      "Alle Spiele & Neuigkeiten",
      "All games & updates"
    ],
    [
      "Alles ansehen",
      "View all"
    ],
    [
      "Alle Motive",
      "All designs"
    ],
    [
      "Produktbilder",
      "Product images"
    ],
    [
      "Dunkle Ansicht",
      "Dark mode"
    ],
    [
      "Helle Ansicht",
      "Light mode"
    ],
    [
      "KLEIDUNG",
      "CLOTHING"
    ],
    [
      "Unsere Pixel-Motive, aufgestickt auf Kleidung für jeden Tag.",
      "Our pixel designs, embroidered on clothes for everyday wear."
    ],
    [
      "Kategorien",
      "Categories"
    ],
    [
      "Alles",
      "Shop all"
    ],
    [
      "meistverkauft",
      "Best selling"
    ],
    [
      "Am relevantesten",
      "Most relevant"
    ],
    [
      "Preis, niedrig nach hoch",
      "Price, low to high"
    ],
    [
      "Preis, hoch nach niedrig",
      "Price, high to low"
    ],
    [
      "Batterie",
      "Battery"
    ],
    [
      "Bier",
      "Beer"
    ],
    [
      "Blitz",
      "Lightning"
    ],
    [
      "Ente",
      "Duck"
    ],
    [
      "Geist",
      "Ghost"
    ],
    [
      "Herz",
      "Heart"
    ],
    [
      "Kaktus",
      "Cactus"
    ],
    [
      "Kraken",
      "Octopuses"
    ],
    [
      "Pinguin",
      "Penguin"
    ],
    [
      "Schnecke",
      "Snail"
    ],
    [
      "Sportwagen",
      "Sports car"
    ],
    [
      "Stern",
      "Star"
    ],
    [
      "Teddybär",
      "Teddy bear"
    ],
    [
      "Spielenavigation",
      "Game navigation"
    ],
    [
      "Stahl. Sand. Noch ein Kampf.",
      "Steel. Sand. One more fight."
    ],
    [
      "Laurel & Bone – Arena-Capsule",
      "Laurel & Bone arena capsule art"
    ],
    [
      "Dein Moment in der Arena.",
      "Your moment in the arena."
    ],
    [
      "Laurel & Bone ist ein Arenaspiel von Retroshapes. Schwert und Schild treffen auf Gegner im Sand: Halte Abstand, finde eine Öffnung und setze deinen nächsten Angriff.",
      "Laurel & Bone is an arena game by Retroshapes. Sword and shield meet opponents in the sand: keep your distance, find an opening, and make your next attack count."
    ],
    [
      "Auf Steam ansehen",
      "View on Steam"
    ],
    [
      "Mitten im Kampf.",
      "In the thick of the fight."
    ],
    [
      "Ein Blick auf Schwert, Schild und Bewegung im Arenakampf.",
      "A look at sword, shield, and movement in arena combat."
    ],
    [
      "Laurel & Bone: Schwert und Schild im Arenakampf",
      "Laurel & Bone: sword and shield combat in the arena"
    ],
    [
      "GIF abspielen",
      "Play GIF"
    ],
    [
      "GIF anhalten",
      "Pause GIF"
    ],
    [
      "GIF ansehen",
      "View GIF"
    ],
    [
      "BEWEGUNG",
      "MOVEMENT"
    ],
    [
      "Finde deine Position.",
      "Find your position."
    ],
    [
      "Behalte die Gegner im Blick und nutze den Platz in der Arena für deinen nächsten Zug.",
      "Keep your opponents in view and use the arena's space to prepare your next move."
    ],
    [
      "NAHKAMPF",
      "CLOSE COMBAT"
    ],
    [
      "Wähle deinen Moment.",
      "Choose your moment."
    ],
    [
      "Angriff und Verteidigung gehören zusammen. Beobachte die Distanz, bevor du in den Nahkampf gehst.",
      "Attack and defence go together. Watch the distance before committing to close combat."
    ],
    [
      "ZEIT ZUM SPIELEN",
      "TAKE A PLAY BREAK"
    ],
    [
      "Noch eine Runde.",
      "One more round."
    ],
    [
      "Springen. Münzen sammeln. Weiter nach oben.",
      "Jump. Collect coins. Keep climbing."
    ],
    [
      "Spiel entdecken",
      "Explore the game"
    ],
    [
      "Eine Wüstenarena. Dein nächster Survival-Run.",
      "A desert arena. Your next survival run."
    ],
    [
      "Pixel zum Spielen.",
      "Pixels to play."
    ],
    [
      "Pixel zum Tragen.",
      "Pixels to wear."
    ],
    [
      "Spielen und tragen",
      "Play and wear"
    ],
    [
      "Schwert, Schild und der richtige Moment. Stell dich dem nächsten Arenakampf.",
      "Sword, shield, and the right moment. Step into your next arena fight."
    ],
    [
      "Kleidungskategorien",
      "Clothing categories"
    ],
    [
      "Karussell",
      "carousel"
    ],
    [
      "Trag deinen Charakter.",
      "Wear your character."
    ],
    [
      "Entdecke Oversized",
      "Explore Oversized"
    ],
    [
      "Kleine Pixel. Jeden Tag.",
      "Small pixels. Everyday tees."
    ],
    [
      "Entdecke T-Shirts",
      "Explore T-Shirts"
    ],
    [
      "Pixel zum Wohlfühlen.",
      "A warmer kind of pixel."
    ],
    [
      "Entdecke Pullover",
      "Explore Sweatshirts"
    ],
    [
      "Pullover",
      "Sweatshirts"
    ],
    [
      "Dein Charakter. Dein Hoodie.",
      "Your character. Your layer."
    ],
    [
      "Entdecke Hoodies",
      "Explore Hoodies"
    ],
    [
      "Pixel auf dem Kopf.",
      "Pixels, top of mind."
    ],
    [
      "Entdecke Caps",
      "Explore Caps"
    ],
    [
      "Dino. Schritt für Schritt.",
      "Dino. Step by step."
    ],
    [
      "Entdecke Socken",
      "Explore Socks"
    ],
    [
      "Socken",
      "Socks"
    ],
    [
      "Kategorie wählen",
      "Choose category"
    ],
    [
      "Start",
      "Play"
    ],
    [
      "Wähle deinen Charakter.",
      "Choose your character."
    ],
    [
      "VOM PIXEL ZUM STICK",
      "FROM PIXEL TO STITCH"
    ],
    [
      "Dein Pixel. Dein Style.",
      "Your pixel. Your style."
    ],
    [
      "Alle Produkte",
      "All clothing"
    ],
    [
      "Vorherige Produkte",
      "Previous products"
    ],
    [
      "Weitere Produkte",
      "More products"
    ],
    [
      "Produkte aus sechs Kategorien",
      "Products from six categories"
    ],
    [
      "Zurück zum PixelDex",
      "Back to PixelDex"
    ],
    [
      "Kollektion entdecken",
      "Explore collection"
    ],
    [
      ", im echten Leben.",
      ", off screen."
    ],
    [
      "Zur Kollektion",
      "View collection"
    ],
    [
      "Die Story",
      "The story"
    ],
    [
      "Nächsten Charakter entdecken.",
      "Meet your next character."
    ],
    [
      "Weitere Charaktere",
      "More characters"
    ],
    [
      "Die Story hinter den Pixeln.",
      "The story behind the pixels."
    ],
    [
      "Hi, ich bin Vincent. Designer, Kind der 90er und mit dem Controller in der Hand aufgewachsen. Mit RetroShapes bringe ich diese Pixel-Nostalgie auf Kleidung für jeden Tag.",
      "Hi, I’m Vincent. A designer and a child of the ’90s, raised with a controller in hand. RetroShapes brings that pixel nostalgia to everyday clothing."
    ],
    [
      "Die Charaktere kennenlernen",
      "Meet the characters"
    ],
    [
      "Online spielen",
      "Play online"
    ],
    [
      "Die Wüste wartet.",
      "The desert is waiting."
    ],
    [
      "Überlebe in der Wüstenarena. Sammle Erfahrung, wähle Upgrades und probiere neue Waffen-Kombinationen. Kostenlos im Browser spielen.",
      "Survive the desert arena. Collect experience, choose upgrades, and try new weapon combinations. Play free in your browser."
    ],
    [
      "Ein Arenaspiel von Retroshapes. Schwert und Schild treffen auf Gegner im Sand: Halte Abstand, finde eine Öffnung und setze deinen nächsten Angriff.",
      "An arena game by Retroshapes. Sword and shield meet opponents in the sand: keep your distance, find an opening, and make your next attack count."
    ],
    [
      "Ein Sprung. Dann noch einer.",
      "One jump. Then another."
    ],
    [
      "Springe von Plattform zu Plattform, sammle Münzen und verbessere deinen Highscore. Waddle Up! läuft kostenlos direkt im Browser.",
      "Jump between platforms, collect coins, and beat your highscore. Waddle Up! plays free in your browser."
    ],
    [
      "Originalspiel · Öffnet online in einem neuen Tab",
      "Original game · Opens online in a new tab"
    ],
    [
      "Zur Bestenliste",
      "View leaderboard"
    ],
    [
      "Immer weiter nach oben",
      "Keep climbing"
    ],
    [
      "Springe von Plattform zu Plattform und klettere immer weiter. Jede Landung ist dein Ausgangspunkt für den nächsten Sprung.",
      "Jump from platform to platform and keep the climb going. Every landing is your starting point for the next leap."
    ],
    [
      "Münzen auf deinem Weg",
      "Coins along the way"
    ],
    [
      "Sammle auf deinem Weg nach oben Münzen. Halte nach der nächsten Gelegenheit Ausschau und behalte deinen Weg über die Plattformen im Blick.",
      "Collect coins as you climb. Look for the next opportunity while keeping your route through the platforms in view."
    ],
    [
      "Dein nächster Highscore",
      "Your next highscore"
    ],
    [
      "Starte einen neuen Versuch für deinen persönlichen Highscore und entdecke die originale Bestenliste. Der nächste Anlauf ist nur einen Sprung entfernt.",
      "Make another run at your personal score, then visit the original leaderboard. A fresh attempt is only a jump away."
    ],
    [
      "Überlebe die Wüstenarena",
      "Survive the desert arena"
    ],
    [
      "Betritt die Wüstenarena und halte deinen Survival-Run am Leben. Bleib im Kampf und arbeite auf dein nächstes Upgrade hin.",
      "Enter the desert arena and keep your survival run alive. Stay in the fight as you work towards your next upgrade."
    ],
    [
      "Erfahrung sammeln, Upgrades wählen",
      "Turn experience into upgrades"
    ],
    [
      "Sammle Erfahrung und wähle im Verlauf deines Runs Upgrades. Jede Entscheidung prägt, wie du dich danach durch die Arena kämpfst.",
      "Gather experience and choose upgrades as your run develops. Each choice shapes how you approach the arena from that point on."
    ],
    [
      "Probiere eine neue Kombination",
      "Try a new combination"
    ],
    [
      "Experimentiere mit Waffenkombinationen und Upgrades. Starte einen neuen Run und probiere einen anderen Weg, die Wüste zu überleben.",
      "Experiment with weapon combinations and upgrades. Come back for another run and try a different approach to surviving the desert."
    ],
    [
      "Mitten in der Wüste.",
      "Out in the desert."
    ],
    [
      "Sieh dir einen Run in der Wüstenarena an. Danach bist du dran: Sammle Erfahrung und wähle deine nächsten Upgrades.",
      "Watch a run in the desert arena. Then take your turn: collect experience and choose your next upgrades."
    ],
    [
      "Ein kleiner Sprung.",
      "A little jump."
    ],
    [
      "Ein Stück höher.",
      "A little higher."
    ],
    [
      "Schau dir den Aufstieg an und starte dann deinen eigenen Run.",
      "Take a look at the climb, then start your own run."
    ],
    [
      "Jetzt spielen",
      "Play now"
    ],
    [
      "Einblick ins Spiel",
      "A look at the game"
    ],
    [
      "Die Bestenliste.",
      "The leaderboard."
    ],
    [
      "Zeitraum",
      "Period"
    ],
    [
      "Alle Zeiten",
      "All time"
    ],
    [
      "Heute",
      "Today"
    ],
    [
      "Letzte 7 Tage",
      "Last 7 days"
    ],
    [
      "Letzte 30 Tage",
      "Last 30 days"
    ],
    [
      "Top 100 des gewählten Zeitraums. Tagesgrenzen nach deiner lokalen Uhrzeit.",
      "Top 100 for the selected period. Day boundaries use your local time."
    ],
    [
      "In diesen Top 100 suchen",
      "Search these top 100"
    ],
    [
      "Top 10 · Alle Zeiten",
      "Top 10 · All time"
    ],
    [
      "Punkte",
      "Score"
    ],
    [
      "Punktestände werden geladen …",
      "Loading scores …"
    ],
    [
      "Zum Laden der Highscores bitte JavaScript aktivieren.",
      "Enable JavaScript to load highscores."
    ],
    [
      "Neu laden",
      "Refresh"
    ],
    [
      "Alle Highscores",
      "More highscores"
    ],
    [
      "Kleine Pixel. Ganze Welten.",
      "Small pixels. Whole worlds."
    ],
    [
      "Eigene Charaktere. Unabhängige Spiele. Etwas zum Mitnehmen.",
      "Original characters. Independent games. Something to take with you."
    ],
    [
      "Charaktere entdecken",
      "Meet the characters"
    ],
    [
      "Kleidung entdecken",
      "Explore clothing"
    ],
    [
      "Unsere Spiele spielen",
      "Play our games"
    ],
    [
      "Kontakt",
      "Contact"
    ],
    [
      "Versand & Lieferung",
      "Shipping & delivery"
    ],
    [
      "Rückgabe",
      "Returns"
    ],
    [
      "Rechtliches",
      "Legal"
    ],
    [
      "Retroshapes Menü",
      "Retroshapes menu"
    ],
    [
      "Produkte suchen",
      "Search products"
    ],
    [
      "Entdecken",
      "Explore"
    ],
    [
      "Spielen",
      "Play"
    ],
    [
      "Tragen",
      "Wear"
    ],
    [
      "Charaktere",
      "Characters"
    ],
    [
      "Pinguin",
      "Penguin"
    ],
    [
      "Charakter entdecken",
      "Explore character"
    ],
    [
      "Geist",
      "Ghost"
    ],
    [
      "Zweites Produktbild",
      "Second product image"
    ],
    [
      "Ab",
      "From"
    ],
    [
      "Ausverkauft",
      "Sold out"
    ],
    [
      "Wird geladen ...",
      "Loading..."
    ],
    [
      "Anbieter:",
      "Vendor:"
    ],
    [
      "Direkt zum Inhalt",
      "Skip to content"
    ],
    [
      "Bewertungen insgesamt",
      "total reviews"
    ],
    [
      "Fehler",
      "Error"
    ],
    [
      "Öffnet externe Webseite.",
      "Opens external website."
    ],
    [
      "Wird in einem neuen Fenster geöffnet.",
      "Opens in a new window."
    ],
    [
      "pro",
      "per"
    ],
    [
      "Ergänzende Produkte",
      "Complementary products"
    ],
    [
      "Einklappbarer Inhalt",
      "Collapsible content"
    ],
    [
      "Schließen",
      "Close"
    ],
    [
      "Wenn du dich für eine Auswahl entscheidest, wird die Seite komplett aktualisiert.",
      "Choosing a selection results in a full page refresh."
    ],
    [
      "Zu Produktinformationen springen",
      "Skip to product information"
    ],
    [
      "Niedriger Lagerbestand",
      "Low stock"
    ],
    [
      "Inkl. Zollgebühren.",
      "Duties included."
    ],
    [
      "Verkaufspreis",
      "Sale price"
    ],
    [
      "Grundpreis",
      "Unit price"
    ],
    [
      "Normaler Preis",
      "Regular price"
    ],
    [
      "Abholung verfügbar",
      "Pickup available"
    ],
    [
      "Verfügbarkeit für Abholungen konnte nicht geladen werden",
      "Couldn't load pickup availability"
    ],
    [
      "Verfügbarkeit in anderen Shops überprüfen",
      "Check availability at other stores"
    ],
    [
      "Shop-Informationen anzeigen",
      "View store information"
    ],
    [
      "Aktualisieren",
      "Refresh"
    ],
    [
      "Variante ausverkauft oder nicht verfügbar",
      "Variant sold out or unavailable"
    ],
    [
      "Vollständige Details anzeigen",
      "View full details"
    ],
    [
      "Produktvarianten",
      "Product variants"
    ],
    [
      "Inkl. Zollgebühren und Steuern.",
      "Duties and taxes included."
    ],
    [
      "Mengenregeln anzeigen",
      "View quantity rules"
    ],
    [
      "Anzahl",
      "Quantity"
    ],
    [
      "Dieses Produkt teilen",
      "Share this product"
    ],
    [
      "3D-Viewer abspielen",
      "Play 3D Viewer"
    ],
    [
      "Galerie-Viewer",
      "Gallery Viewer"
    ],
    [
      "Video abspielen",
      "Play video"
    ],
    [
      "Nicht vorrätig",
      "Out of stock"
    ],
    [
      "\"Ansicht in deinem Raum\" lädt den Artikel in ein Augmented-Reality-Fenster",
      "View in your space, loads item in augmented reality window"
    ],
    [
      "In deinem Bereich ansehen",
      "View in your space"
    ],
    [
      "In den Warenkorb",
      "Add to cart"
    ],
    [
      "Volumenabhängige Preisgestaltung verfügbar",
      "Volume pricing available"
    ],
    [
      "Volumenabhängige Preisgestaltung",
      "Volume Pricing"
    ],
    [
      "Anbieter",
      "Vendor"
    ],
    [
      "Nicht verfügbar",
      "Unavailable"
    ],
    [
      "Auf Lager",
      "In stock"
    ],
    [
      "Jetzt Kaufen",
      "Choose options"
    ],
    [
      "Beschreibung",
      "Description"
    ],
    [
      "Bis",
      "To"
    ],
    [
      "Alle entfernen",
      "Remove all"
    ],
    [
      "Sortieren nach:",
      "Sort by:"
    ],
    [
      "Weniger anzeigen",
      "Show less"
    ],
    [
      "Anwenden",
      "Apply"
    ],
    [
      "Filter entfernen",
      "Remove filter"
    ],
    [
      "Zurücksetzen",
      "Reset"
    ],
    [
      "Allen entsprechen",
      "Match all"
    ],
    [
      "Löschen",
      "Clear"
    ],
    [
      "Mehr anzeigen",
      "Show more"
    ],
    [
      "Von",
      "From"
    ],
    [
      "Filtern und sortieren",
      "Filter and sort"
    ],
    [
      "Sortieren",
      "Sort"
    ],
    [
      "Medien-Galerie",
      "Media gallery"
    ],
    [
      "Alle anzeigen",
      "View all"
    ],
    [
      "Inkl. Zollgebühren. Steuern, Rabatte und Versand werden beim Checkout berechnet.",
      "Duties included. Taxes, discounts and shipping calculated at checkout."
    ],
    [
      "§19 UStG (keine MwSt.) zzgl. Versand 5€",
      "Taxes included. Discounts and shipping calculated at checkout."
    ],
    [
      "Gesamtsumme",
      "Total"
    ],
    [
      "Preis",
      "Price"
    ],
    [
      "Produktbild",
      "Product image"
    ],
    [
      "Produkt",
      "Product"
    ],
    [
      "Steuern, Rabatte und Versand werden beim Checkout berechnet.",
      "Taxes, discounts and shipping calculated at checkout."
    ],
    [
      "Inkl. Zollgebühren und Steuern. Rabatte und Versand werden beim Checkout berechnet.",
      "Duties and taxes included. Discounts and shipping calculated at checkout."
    ],
    [
      "Hast du ein Konto?",
      "Have an account?"
    ],
    [
      "Artikel im Warenkorb",
      "Cart items"
    ],
    [
      "Spezielle Bestellanweisungen",
      "Order special instructions"
    ],
    [
      "Gesamt",
      "Estimated total"
    ],
    [
      "Neuer geschätzter Gesamtbetrag",
      "New estimated total"
    ],
    [
      "Beim Aktualisieren deines Warenkorbs ist ein Fehler aufgetreten. Bitte versuche es erneut.",
      "There was an error while updating your cart. Please try again."
    ],
    [
      "Dein Warenkorb ist leer",
      "Your cart is empty"
    ],
    [
      "Dein Warenkorb",
      "Your cart"
    ],
    [
      "Zur Kasse",
      "Check out"
    ],
    [
      "Vorherige Folie",
      "Previous slide"
    ],
    [
      "Folie laden",
      "Load slide"
    ],
    [
      "Slideshow abspielen",
      "Play slideshow"
    ],
    [
      "Folie",
      "Slide"
    ],
    [
      "Slideshow pausieren",
      "Pause slideshow"
    ],
    [
      "Nächste Folie",
      "Next slide"
    ],
    [
      "Zahlungsmethoden",
      "Payment methods"
    ],
    [
      "Produktzwischensumme",
      "Product subtotal"
    ],
    [
      "Varianten insgesamt",
      "Variant total"
    ],
    [
      "Warenkorb ansehen",
      "View cart"
    ],
    [
      "Variante",
      "Variant"
    ],
    [
      "Abbrechen",
      "Cancel"
    ],
    [
      "Artikel gesamt",
      "Total items"
    ],
    [
      "1 Artikel aus dem Warenkorb entfernen?",
      "Remove 1 item from your cart?"
    ],
    [
      "Ankündigung",
      "Announcement"
    ],
    [
      "Vorherige Ankündigung",
      "Previous announcement"
    ],
    [
      "Nächste Ankündigung",
      "Next announcement"
    ],
    [
      "Ankündigungsleiste",
      "Announcement bar"
    ],
    [
      "Menü",
      "Menu"
    ],
    [
      "Verschaffe deinen Kunden eine Übersicht über deinen Blog-Beitrag",
      "Give your customers a summary of your blog post"
    ],
    [
      "Blog-Beitrag",
      "Blog post"
    ],
    [
      "Keine Produkte gefunden",
      "No products found"
    ],
    [
      "Kategorie",
      "Collection"
    ],
    [
      "Seitentitel",
      "Page title"
    ],
    [
      "Mit Passwort betreten",
      "Enter using password"
    ],
    [
      "Dein Passwort",
      "Your password"
    ],
    [
      "Falsches Passwort!",
      "Wrong password!"
    ],
    [
      "Passwort",
      "Password"
    ],
    [
      "Shop mit Passwort betreten:",
      "Enter store using password:"
    ],
    [
      "Eingeben",
      "Enter"
    ],
    [
      "von",
      "of"
    ],
    [
      "Nach rechts schieben",
      "Slide right"
    ],
    [
      "Nach links schieben",
      "Slide left"
    ],
    [
      "Teilen schließen",
      "Close share"
    ],
    [
      "Link in die Zwischenablage kopiert",
      "Link copied to clipboard"
    ],
    [
      "Link kopieren",
      "Copy link"
    ],
    [
      "Suchbegriff zurücksetzen",
      "Clear search term"
    ],
    [
      "Suchen",
      "Search"
    ],
    [
      "Artikel wurde in den Warenkorb gelegt",
      "Item added to your cart"
    ],
    [
      "Weiter shoppen",
      "Continue shopping"
    ],
    [
      "Auf Pinterest pinnen",
      "Pin on Pinterest"
    ],
    [
      "Auf Facebook teilen",
      "Share on Facebook"
    ],
    [
      "Auf X teilen",
      "Share on X"
    ],
    [
      "Seitennummerierung",
      "Pagination"
    ],
    [
      "Vorherige Seite",
      "Previous page"
    ],
    [
      "Nächste Seite",
      "Next page"
    ],
    [
      "Warenkorb",
      "Cart"
    ],
    [
      "Seite nicht gefunden",
      "Page not found"
    ],
    [
      "Vorschläge",
      "Suggestions"
    ],
    [
      "Seiten",
      "Pages"
    ],
    [
      "Produkte",
      "Products"
    ],
    [
      "Suchergebnisse",
      "Search results"
    ],
    [
      "Seite",
      "Page"
    ],
    [
      "Kommentar",
      "Comment"
    ],
    [
      "Kontaktformular",
      "Contact form"
    ],
    [
      "Danke, dass du uns kontaktiert hast. Wir werden uns so schnell wie möglich bei dir melden.",
      "Thanks for contacting us. We'll get back to you as soon as possible."
    ],
    [
      "Senden",
      "Send"
    ],
    [
      "Bitte passe Folgendes an:",
      "Please adjust the following:"
    ],
    [
      "E-Mail",
      "Email"
    ],
    [
      "Telefonnummer",
      "Phone number"
    ],
    [
      "Abonnieren",
      "Subscribe"
    ],
    [
      "Danke für deine Anmeldung",
      "Thanks for subscribing"
    ],
    [
      "Kleidung",
      "Clothing"
    ],
    [
      "Spiele",
      "Games"
    ],
    [
      "Alle Charaktere",
      "All characters"
    ],
    [
      "Warenkorb öffnen",
      "Open cart"
    ],
    [
      "Menü öffnen",
      "Open menu"
    ],
    [
      "Menü schließen",
      "Close menu"
    ],
    [
      "Nach oben",
      "Back to top"
    ],
    [
      "Farbe",
      "Color"
    ],
    [
      "Größe",
      "Size"
    ],
    [
      "Grösse",
      "Size"
    ],
    [
      "Farbe wählen",
      "Choose color"
    ],
    [
      "Größe wählen",
      "Choose size"
    ],
    [
      "Jetzt kaufen",
      "Buy now"
    ],
    [
      "Weiter einkaufen",
      "Continue shopping"
    ],
    [
      "Versand & Bonus",
      "Shipping & bonus"
    ],
    [
      "Versand",
      "Shipping"
    ],
    [
      "Lieferung",
      "Delivery"
    ],
    [
      "Lieferzeit",
      "Delivery time"
    ],
    [
      "Lieferzeiten",
      "Delivery times"
    ],
    [
      "Versandkosten",
      "Shipping costs"
    ],
    [
      "Kostenloser Versand",
      "Free shipping"
    ],
    [
      "Kostenloser Versand ab",
      "Free shipping from"
    ],
    [
      "Verfügbar",
      "Available"
    ],
    [
      "Stickdetail anzeigen",
      "Show stitch detail"
    ],
    [
      "Bewertungen",
      "Reviews"
    ],
    [
      "Bewertung schreiben",
      "Write a review"
    ],
    [
      "Verifizierter Kauf",
      "Verified purchase"
    ],
    [
      "Mehr laden",
      "Load more"
    ],
    [
      "Neueste zuerst",
      "Newest first"
    ],
    [
      "Beste zuerst",
      "Highest rated"
    ],
    [
      "Schwarz",
      "Black"
    ],
    [
      "Weiß",
      "White"
    ],
    [
      "Weiss",
      "White"
    ],
    [
      "Natur",
      "Natural"
    ],
    [
      "Blau",
      "Blue"
    ],
    [
      "Grün",
      "Green"
    ],
    [
      "Rot",
      "Red"
    ],
    [
      "Rosa",
      "Pink"
    ],
    [
      "Grau",
      "Gray"
    ],
    [
      "Dunkelgrau",
      "Dark gray"
    ],
    [
      "Dunkelblau",
      "Navy"
    ],
    [
      "Hellblau",
      "Light blue"
    ],
    [
      "Braun",
      "Brown"
    ],
    [
      "Gelb",
      "Yellow"
    ],
    [
      "Lila",
      "Purple"
    ],
    [
      "Datenschutzerklärung",
      "Privacy policy"
    ],
    [
      "Datenschutz",
      "Privacy"
    ],
    [
      "Widerrufsrecht",
      "Right of withdrawal"
    ],
    [
      "Widerrufsbelehrung",
      "Withdrawal policy"
    ],
    [
      "AGB",
      "Terms and conditions"
    ],
    [
      "Impressum",
      "Legal notice"
    ],
    [
      "Nutzungsbedingungen",
      "Terms of service"
    ],
    [
      "Rückerstattungsrichtlinie",
      "Refund policy"
    ],
    [
      "Versandrichtlinie",
      "Shipping policy"
    ],
    [
      "Einzelheiten",
      "Details"
    ],
    [
      "Produktdetails",
      "Product details"
    ],
    [
      "Material & Pflege",
      "Materials & care"
    ],
    [
      "Größentabelle",
      "Size chart"
    ],
    [
      "Pflegehinweise",
      "Care instructions"
    ],
    [
      "Bonusartikel",
      "Bonus items"
    ],
    [
      "Suche",
      "Search"
    ],
    [
      "Filter und Sortierung",
      "Filter and sort"
    ],
    [
      "Sortieren nach",
      "Sort by"
    ],
    [
      "Dein Charakter",
      "Your character"
    ],
    [
      "Unsere Spiele",
      "Our games"
    ],
    [
      "Bestickte Streetwear",
      "Embroidered streetwear"
    ],
    [
      "Frisch bestickt – in 2 bis 3 Werktagen bei dir",
      "Freshly embroidered – with you in 2 to 3 business days"
    ],
    [
      "100% Bio-Baumwolle & GOTS-zertifiziert",
      "100% organic cotton & GOTS-certified"
    ],
    [
      "Hochwertige Stickerei statt Print",
      "Premium embroidery instead of print"
    ],
    [
      "Bestickt in Bayern & 30 Tage Rückgabe",
      "Embroidered in Bavaria & 30-day returns"
    ],
    [
      "Nicht sicher mit der Größe?",
      "Not sure about your size?"
    ],
    [
      "Motiv",
      "Design"
    ],
    [
      "Nicht aus dieser Retro-Welt",
      "Out of this retro world"
    ],
    [
      "Gratis-Dino-Socken",
      "Free Dino socks"
    ],
    [
      "Gratis Dino-Socken",
      "Free Dino socks"
    ],
    [
      "Versandkostenfrei und deine Gratis-Dino-Socken sind gesichert!",
      "Free shipping and your free Dino socks are secured!"
    ],
    [
      "Ab 64 €",
      "From €64"
    ],
    [
      "Ab 80 € nach Rabatt",
      "From €80 after discounts"
    ],
    [
      "Gesamt",
      "Total"
    ],
    [
      "Inkl. MwSt. · Versandkostenfrei",
      "Including VAT · Free shipping"
    ],
    [
      "GRATIS",
      "FREE"
    ],
    [
      "Gratis-Geschenk",
      "Free gift"
    ],
    [
      "Schließen",
      "Close"
    ],
    [
      "Frisch bestickt",
      "Freshly embroidered"
    ],
    [
      "– in 2 bis 3 Werktagen bei dir",
      "– with you in 2 to 3 business days"
    ],
    [
      "in 2 bis 3 Werktagen bei dir",
      "with you in 2 to 3 business days"
    ],
    [
      "100% Bio-Baumwolle",
      "100% organic cotton"
    ],
    [
      "GOTS-zertifiziert",
      "GOTS-certified"
    ],
    [
      "Bestickt in Bayern",
      "Embroidered in Bavaria"
    ],
    [
      "30 Tage Rückgabe",
      "30-day returns"
    ],
    [
      "nach Rabatt",
      "after discounts"
    ],
    [
      "Keine passenden Namen in dieser Liste.",
      "No matching names in this list."
    ],
    [
      "Noch keine Punktestände.",
      "No scores yet."
    ],
    [
      "Highscores derzeit nicht verfügbar. Bitte erneut versuchen.",
      "Scores unavailable. Please try again."
    ],
    [
      "Hersteller",
      "Manufacturer"
    ],
    [
      "Verfügbarkeit",
      "Availability"
    ],
    [
      "Produkttyp",
      "Product type"
    ],
    [
      "Produktart",
      "Product type"
    ],
    [
      "Marke",
      "Brand"
    ],
    [
      "Alphabetisch, A-Z",
      "Alphabetically, A-Z"
    ],
    [
      "Alphabetisch, Z-A",
      "Alphabetically, Z-A"
    ],
    [
      "Preis, niedrig zu hoch",
      "Price, low to high"
    ],
    [
      "Preis, hoch zu niedrig",
      "Price, high to low"
    ],
    [
      "Datum, alt zu neu",
      "Date, old to new"
    ],
    [
      "Datum, neu zu alt",
      "Date, new to old"
    ],
    [
      "Ausgewählt",
      "Featured"
    ],
    [
      "Meistverkauft",
      "Best selling"
    ],
    [
      "Bestseller",
      "Best selling"
    ],
    [
      "Trag deinen",
      "Wear your"
    ],
    [
      "Charakter.",
      "character."
    ],
    [
      "Kleine Pixel.",
      "Small pixels."
    ],
    [
      "Jeden Tag.",
      "Everyday tees."
    ],
    [
      "Pixel zum",
      "Warm layers."
    ],
    [
      "Wohlfühlen.",
      "Cool pixels."
    ],
    [
      "Dein Charakter.",
      "Your character."
    ],
    [
      "Dein Hoodie.",
      "Your hoodie."
    ],
    [
      "Pixel auf",
      "Pixels on top."
    ],
    [
      "dem Kopf.",
      "Style all day."
    ],
    [
      "Dein Dino.",
      "Your dino."
    ],
    [
      "Dein Schritt.",
      "Every step."
    ],
    [
      "Alle Games",
      "All games"
    ],
    [
      "Laurel & Bone: Zwei Gladiatoren mit Helmen im Schwertkampf",
      "Laurel & Bone: two helmeted gladiators in a sword fight"
    ],
    [
      "Jede Klinge zählt.",
      "Every blade counts."
    ],
    [
      "Physikbasierter Gladiatorenkampf im klobigen Retro-Look. Echte Klingen, echte Schilde, echte Treffer. Überlebe die Arena – allein, im lokalen Koop oder gegen einen Freund.",
      "Physics-based gladiator combat in a chunky retro look. Real blades, real shields, real hits. Survive the arena solo, in local co-op, or against a friend."
    ],
    [
      "Trailer ansehen",
      "Watch the trailer"
    ],
    [
      "Das Spiel auf einen Blick",
      "The game at a glance"
    ],
    [
      "Gladiatorenklassen",
      "gladiator classes"
    ],
    [
      "Spieler · lokal",
      "players · local"
    ],
    [
      "Endlos",
      "Endless"
    ],
    [
      "Eine Arena. Ein Leben.",
      "One arena. One life."
    ],
    [
      "Laurel & Bone Gameplay-Trailer",
      "Laurel & Bone gameplay trailer"
    ],
    [
      "Trailer als MP4 öffnen",
      "Open the MP4 trailer"
    ],
    [
      "Enthält stilisiertes Blut und Gladiatorenkämpfe. Das Spiel befindet sich in Entwicklung.",
      "Contains stylized blood and gladiator combat. The game is in development."
    ],
    [
      "PHYSIKBASIERTER KAMPF",
      "PHYSICAL COMBAT"
    ],
    [
      "Lies die Deckung.",
      "Read the guard."
    ],
    [
      "Finde die Öffnung.",
      "Find your opening."
    ],
    [
      "Schwert, Speer, Schild und Pfeil sind physische Objekte. Klingen prallen aufeinander, Schilde blocken wirklich und ein Tritt schafft Abstand. Ziele deinen Schlag und nutze deine Reichweite.",
      "Swords, spears, shields and arrows are physical objects. Blades clash, shields really block, and a kick creates space. Aim your strike and use your reach."
    ],
    [
      "Eine Schwertklinge trifft beim Parieren auf einen Schild",
      "A sword blade meets a shield during a parry"
    ],
    [
      "Klingen, Deckung und der richtige Moment.",
      "Blades, guard, and the right moment."
    ],
    [
      "Spielmodi",
      "Game modes"
    ],
    [
      "Ein Leben.",
      "One life."
    ],
    [
      "Wie weit kommst du?",
      "How far can you go?"
    ],
    [
      "Aus Duellen werden Paare und Gruppen mit bis zu vier Gegnern. Löwen, Bären und Wolfsrudel betreten den Sand. Zwischen den Kämpfen investierst du Gold in Rüstung, Training und Handwerk, wählst Talente und deinen nächsten Vertrag.",
      "Duels become pairs and groups of up to four opponents. Lions, bears and wolf packs enter the sand. Between fights, invest gold in armor, training and crafting, choose talents and your next contract."
    ],
    [
      "Gemeinsam rein.",
      "Fight together."
    ],
    [
      "Oder gegeneinander.",
      "Or face each other."
    ],
    [
      "Bestreitet die endlose Arena im lokalen Koop oder tretet im lokalen Versus gegeneinander an. Tastatur und Maus, Controller oder zwei Controller an einem Rechner.",
      "Take on the Endless arena in local co-op, or face each other in local versus. Keyboard and mouse, a controller, or two controllers on one computer."
    ],
    [
      "Direkt aus der Arena.",
      "Straight from the arena."
    ],
    [
      "Bilder antippen zum Vergrößern",
      "Tap an image to enlarge"
    ],
    [
      "Gameplay-Bilder, auf Mobilgeräten seitlich wischen",
      "Gameplay images, swipe sideways on mobile"
    ],
    [
      "Schwert und Schild im Duell – großes Bild öffnen",
      "Sword and shield duel – open full image"
    ],
    [
      "Zwei Klingen gegen einen Dreizack – großes Bild öffnen",
      "Twin blades against a trident – open full image"
    ],
    [
      "Ein Löwe betritt die Arena – großes Bild öffnen",
      "A lion enters the arena – open full image"
    ],
    [
      "Kampf gegen einen Bären – großes Bild öffnen",
      "Facing a bear – open full image"
    ],
    [
      "Lokales Versus: Spieler gegen Spieler – großes Bild öffnen",
      "Local versus: player against player – open full image"
    ],
    [
      "Zwischen den Kämpfen: Waffenkammer und Markt – großes Bild öffnen",
      "Between fights: Armory and Market – open full image"
    ],
    [
      "Schwert und Schild im Duell",
      "Sword and shield duel"
    ],
    [
      "Zwei Klingen gegen einen Dreizack",
      "Twin blades against a trident"
    ],
    [
      "Ein Löwe betritt die Arena",
      "A lion enters the arena"
    ],
    [
      "Kampf gegen einen Bären",
      "Facing a bear"
    ],
    [
      "Lokales Versus: Spieler gegen Spieler",
      "Local versus: player against player"
    ],
    [
      "Zwischen den Kämpfen: Waffenkammer und Markt",
      "Between fights: Armory and Market"
    ],
    [
      "großes Bild öffnen",
      "open full image"
    ],
    [
      "DEIN KAMPFSTIL",
      "YOUR FIGHTING STYLE"
    ],
    [
      "Zehn Klassen.",
      "Ten classes."
    ],
    [
      "Deine Entscheidung.",
      "Your choice."
    ],
    [
      "Schwert und großer Schild, Krummklinge und kleiner Schild, Speer, Dreizack, zwei Klingen oder Bogen. Jede Klasse bringt ihre eigene Ausrüstung, Geschwindigkeit, Balance und Reichweite mit.",
      "Sword and large shield, curved blade and small shield, spear, trident, twin blades or bow. Each class brings its own equipment, speed, balance and reach."
    ],
    [
      "Der nächste Kampf wartet.",
      "The next fight awaits."
    ],
    [
      "Neue Einblicke und Neuigkeiten zum Release von Laurel & Bone: mit den Games-Updates von Retroshapes.",
      "New previews and news about the Laurel & Bone release: with game updates from Retroshapes."
    ],
    [
      "Updates per E-Mail erhalten",
      "Get updates by email"
    ],
    [
      "Inhaltshinweis",
      "Content note"
    ],
    [
      "Stilisierte Gladiatorengewalt mit Blut und abgetrennten Gliedmaßen, auch Todesstöße wie Enthauptungen. Kämpfe gegen Tiere. Blut lässt sich in den Einstellungen reduzieren oder abschalten.",
      "Stylized gladiator violence with blood and dismemberment, including finishing moves such as decapitation. Combat against animals. Blood can be reduced or switched off in the settings."
    ],
    [
      "Jede Klinge zählt. Physikbasierter Gladiatorenkampf – allein, im lokalen Koop oder gegen einen Freund.",
      "Every blade counts. Physics-based gladiator combat – solo, in local co-op, or against a friend."
    ],
    [
      "Trailer & Gameplay ansehen",
      "Watch trailer & gameplay"
    ],
    [
      "Die Story hinter den Pixeln",
      "The story behind the pixels"
    ],
    [
      "Hi, ich bin Vincent. Designer, Kind der 90er und mit dem Controller in der Hand aufgewachsen. RetroShapes ist mein unabhängiges Studio für eigene Charaktere, Spiele und bestickte Kleidung.",
      "Hi, I'm Vincent. A designer, a child of the 90s, and someone who grew up with a controller in hand. RetroShapes is my independent studio for original characters, games, and embroidered clothing."
    ],
    [
      "Angefangen hat alles mit einer Frage: Wie bringe ich die Pixel-Welten, die mich geprägt haben, in den Alltag? Erst als kleine Stickmotive auf hochwertigen Basics. Heute werden daraus auch eigene Spiele. Die Idee bleibt dieselbe: kleine Pixel, die etwas in dir auslösen.",
      "It started with a question: how could I bring the pixel worlds I grew up with into everyday life? First, through small embroidered designs on quality basics. Now, through original games too. The idea stays the same: small pixels that make you feel something."
    ],
    [
      "Zwei Spiele sind schon da. Weitere kommen.",
      "Two games are already here. More are on the way."
    ],
    [
      "RetroShapes soll nicht nur an alte Lieblingsspiele erinnern. Hier entstehen neue. Zwei eigene Browser-Spiele kannst du bereits entdecken:",
      "RetroShapes isn't just about remembering old favourites. It's about making new ones. Two original browser games are already here for you to discover:"
    ],
    [
      "Waddle Up!",
      "Waddle Up!"
    ],
    [
      "Springen, Münzen sammeln und immer weiter nach oben. Eine kleine Spielpause, bei der es selten bei einem Versuch bleibt.",
      "Jump, collect coins, and keep climbing. A little play break that rarely ends after just one try."
    ],
    [
      "Desert Peng",
      "Desert Peng"
    ],
    [
      "Eine Wüstenarena und dein nächster Survival-Run. Rein ins Spiel, durchhalten und noch eine Runde versuchen.",
      "A desert arena and your next survival run. Jump in, hold out, and give it one more go."
    ],
    [
      "Und dabei bleibt es nicht: Weitere Spiele sind in Arbeit. RetroShapes wächst als kleines Indie-Studio weiter – mit neuen Ideen, eigenen Welten und Platz für die Community.",
      "And that's just the beginning: more games are in the works. RetroShapes is growing as a small indie studio, with new ideas, original worlds, and room for the community."
    ],
    [
      "Spiele entdecken & Games-Updates erhalten",
      "Explore games & get game updates"
    ],
    [
      "Vom Pixel zum Lieblingsstück.",
      "From pixels to favourite pieces."
    ],
    [
      "Die Kleidung bleibt ein Teil dieser Welt: kleine Charaktere, sauber gestickt auf Basics für jeden Tag. Keine austauschbaren Logos, sondern Motive mit einer eigenen Geschichte.",
      "Clothing remains part of this world: little characters, carefully embroidered on everyday basics. Each design has a story of its own."
    ],
    [
      "Pixel für Pixel. Von Hand.",
      "Pixel by pixel. By hand."
    ],
    [
      "Jedes Motiv entwerfe ich selbst. Dabei frage ich mich: Würde ich das selbst tragen? Nur was diese Prüfung besteht, wird gepixelt, getestet und Teil des PixelDex – unseres wachsenden Archivs mit eigenen Nummern und kleinen Geschichten.",
      "I design every motif myself, always asking: would I wear this? Only the designs that pass that test are drawn, tried out, and added to the PixelDex, our growing archive of numbered characters and their stories."
    ],
    [
      "Manche Designs entstehen auch zusammen mit der Community und Partnern, die denselben Anspruch teilen. Gemeinsame Ideen, getragen von der Liebe zum Detail.",
      "Some designs also take shape with the community and partners who share the same care for their work. Shared ideas, brought to life through attention to detail."
    ],
    [
      "Produziert, wenn du auf Start drückst.",
      "Made when you press Start."
    ],
    [
      "Kein Lager voller unverkaufter Shirts. Keine Überproduktion. Wir produzieren on-demand – erst wenn du bestellst, nur was wirklich gebraucht wird.",
      "No warehouse full of unsold shirts. No overproduction. We produce on demand, after you order, making only what is needed."
    ],
    [
      "Wir sticken statt zu drucken: kleine Motive, die du nicht nur sehen, sondern auch fühlen kannst. Bestickt und versendet wird in unserer eigenen kleinen Produktion in der Nähe des Chiemsees.",
      "We embroider rather than print: little designs you can feel as well as see. Embroidery and shipping happen in our own small workshop near Lake Chiemsee in Bavaria."
    ],
    [
      "Die vierbeinige Qualitätskontrolle.",
      "Four-legged quality control."
    ],
    [
      "Zelda ist für Motivation, Pflichtpausen und die abschließende Fell-Inspektion jedes Produktmusters zuständig. Ob das ein Feature oder ein Bug ist, haben wir noch nicht entschieden.",
      "Zelda handles motivation, mandatory breaks, and the final fur inspection of every product sample. We haven't decided whether that's a feature or a bug."
    ],
    [
      "Was wir wissen: Die besten Ideen kommen meistens beim Gassigehen. Zelda weiß das.",
      "What we do know: the best ideas usually come during a walk. Zelda knows this."
    ],
    [
      "Ob du eine Runde spielst, deinen Lieblingscharakter im PixelDex findest oder ihn als Stickerei mitnimmst: Du bist Teil derselben kleinen Welt. Danke, dass du ein unabhängiges Studio unterstützt – und mit uns schaust, was als Nächstes kommt.",
      "Whether you play a round, find your favourite character in the PixelDex, or take them with you as embroidery, you're part of the same little world. Thanks for supporting an independent studio and joining us to see what comes next."
    ],
    [
      "Noch eine Runde? Zu den Spielen",
      "One more round? Explore the games"
    ],
    [
      "Nahaufnahme der Dackel-Gustl-Stickerei auf weißer Bio-Baumwolle",
      "Close-up of the Gustl dachshund embroidery on white organic cotton"
    ],
    [
      "Die Story hinter den Pixeln – RetroShapes",
      "The story behind the pixels – RetroShapes"
    ],
    [
      "RetroShapes ist Vincents Indie-Studio für eigene Charaktere, Browser-Spiele und bestickte Kleidung. Zwei Spiele sind schon da, weitere entstehen.",
      "RetroShapes is Vincent's indie studio for original characters, browser games, and embroidered clothing. Two games are here, with more on the way."
    ],
    [
      "Shop-Bewertungen",
      "shop reviews"
    ],
    [
      "Ein Paar ab 128 € Warenwert, ohne Versand. Nicht mit Produkt- oder Bestellrabatten kombinierbar. Größe wählbar.",
      "One pair from €128 in merchandise, excluding shipping. Cannot be combined with product or order discounts. Choose your size."
    ],
    [
      "Rabatt aktiv · Gratis-Socken sind nicht mit Produkt- oder Bestellrabatten kombinierbar.",
      "Discount active · Free socks cannot be combined with product or order discounts."
    ],
    [
      "Geschenkaktion wird geprüft",
      "Gift eligibility is being checked"
    ],
    [
      "Angenehm auf der Haut – Materialdetails unten",
      "Comfortable to wear – see material details below"
    ],
    [
      "In 2–3 Werktagen bei dir (DE)",
      "With you in 2–3 business days (Germany)"
    ],
    [
      "One Size · mit Metallschnalle verstellbar",
      "One size · adjustable metal clasp"
    ],
    [
      "In 2–3 Werktagen bei dir.",
      "With you in 2–3 business days."
    ],
    [
      "Ca. 6–10 Werktage in die Schweiz.",
      "About 6–10 business days to Switzerland."
    ],
    [
      "Einfuhrabfertigung kann länger dauern.",
      "Customs clearance can take longer."
    ],
    [
      "Ca. 3–10 Werktage innerhalb der EU.",
      "About 3–10 business days within the EU."
    ],
    [
      "Lieferzeit und Versand ansehen",
      "See delivery times and shipping"
    ],
    [
      "Dein Motiv. Noch mehr Styles.",
      "Your character. More ways to wear it."
    ],
    [
      "Farben",
      "colors"
    ],
    [
      "Stickfarben",
      "embroidery colors"
    ],
    [
      "Ein Paar ab 128 € Warenwert, ohne Versand. Nicht mit Produkt- oder Bestellrabatten kombinierbar. Größe wählbar. Solange vorrätig.",
      "One pair from €128 in merchandise, excluding shipping. Cannot be combined with product or order discounts. Choose your size. While stocks last."
    ],
    [
      "Versand und Geschenkaktion werden zum aktuellen Wechselkurs im Checkout geprüft. Gratis-Socken ab 128 € Warenwert; maximal ein Paar, nicht mit Produkt- oder Bestellrabatten kombinierbar.",
      "Shipping and the gift offer are checked at the current exchange rate at checkout. Free socks from €128 in merchandise; one pair maximum, cannot be combined with product or order discounts."
    ],
    [
      "Versand und Einfuhrabgaben werden im Checkout berechnet",
      "Shipping and import charges are calculated at checkout"
    ],
    [
      "Bestickte Cord-Caps mit unseren Pixel-Motiven. One Size, verstellbar und in Bayern bestickt.",
      "Cord caps embroidered with our pixel characters. One size, adjustable and embroidered in Bavaria."
    ],
    [
      "Dein Pixel.",
      "Your pixel."
    ],
    [
      "Deine Cap.",
      "Your cap."
    ],
    [
      "Bestickte Cord-Caps. In Bayern veredelt.",
      "Embroidered cord caps. Finished in Bavaria."
    ],
    [
      "Bestickte Caps ansehen",
      "Shop embroidered caps"
    ],
    [
      "Dein Charakter auf Cap, Shirt oder Hoodie.",
      "Your character on a cap, tee or hoodie."
    ],
    [
      "Pixel, die bleiben.",
      "Pixels that stay."
    ],
    [
      "Präzise Stickerei statt Print. Dein Motiv bekommt Struktur – direkt bei uns in Bayern.",
      "Precise embroidery instead of print. Your character gains texture, right here in Bavaria."
    ],
    [
      "So entsteht dein Teil",
      "How your piece is made"
    ],
    [
      "Größentabelle",
      "Size guide"
    ],
    [
      "Alle Spiele",
      "All games"
    ]
  ],
  "productPhrases": [
    [
      "Bestickter Bio Hoodie",
      "Embroidered Organic Hoodie"
    ],
    [
      "Bestickter Bio Pullover",
      "Embroidered Organic Sweatshirt"
    ],
    [
      "RetroShapes Pinguin Stickerset",
      "RetroShapes Penguin Sticker Set"
    ],
    [
      "RetroShapes Stickerset",
      "RetroShapes Sticker Set"
    ],
    [
      "Pixel Pinguin Mit Skateboard",
      "Pixel Penguin with Skateboard"
    ],
    [
      "Pixel Pinguin Mit Cowboyhut",
      "Pixel Penguin with Cowboy Hat"
    ],
    [
      "Pixel Pinguin Mit Krone",
      "Pixel Penguin with Crown"
    ],
    [
      "Pixel Pinguin Mit Zauberhut",
      "Pixel Penguin with Wizard Hat"
    ],
    [
      "Pixel Alien Blau",
      "Pixel Blue Alien"
    ],
    [
      "Pixel Alien Orange",
      "Pixel Orange Alien"
    ],
    [
      "Pixel Alien Rot",
      "Pixel Red Alien"
    ],
    [
      "Pixel Dino Blau",
      "Pixel Blue Dino"
    ],
    [
      "Pixel Dino Orange",
      "Pixel Orange Dino"
    ],
    [
      "Pixel Dino Rot",
      "Pixel Red Dino"
    ],
    [
      "Pixel Herz Blau",
      "Pixel Blue Heart"
    ],
    [
      "Pixel Herz Orange",
      "Pixel Orange Heart"
    ],
    [
      "Pixel Herz Rot",
      "Pixel Red Heart"
    ],
    [
      "Pixel Batterie",
      "Pixel Battery"
    ],
    [
      "Pixel Bier",
      "Pixel Beer"
    ],
    [
      "Pixel Ente",
      "Pixel Duck"
    ],
    [
      "Pixel Herz",
      "Pixel Heart"
    ],
    [
      "Pixel Kaktus",
      "Pixel Cactus"
    ],
    [
      "Pixel Krake",
      "Pixel Octopus"
    ],
    [
      "Pixel Schnecke",
      "Pixel Snail"
    ],
    [
      "Pixel Stern",
      "Pixel Star"
    ],
    [
      "T-Shirt Schwarz",
      "T-Shirt Black"
    ],
    [
      "Besticktes Bio Oversized T-Shirt",
      "Embroidered Organic Oversized T-Shirt"
    ],
    [
      "Bestickte Bio-Baumwoll-Socken",
      "Embroidered organic cotton socks"
    ],
    [
      "Bestickte Bio Baumwoll Socken",
      "Embroidered organic cotton socks"
    ],
    [
      "Besticktes Oversized T-Shirt",
      "Embroidered oversized T-shirt"
    ],
    [
      "Besticktes Bio T-Shirt",
      "Embroidered Organic T-Shirt"
    ],
    [
      "Pixel Sportwagen braun",
      "Pixel Brown Sports Car"
    ],
    [
      "Bestickter Pullover",
      "Embroidered sweatshirt"
    ],
    [
      "Bio-Baumwoll-Socken",
      "Organic cotton socks"
    ],
    [
      "Besticktes T-Shirt",
      "Embroidered T-shirt"
    ],
    [
      "Bestickte Cord Cap",
      "Embroidered cord cap"
    ],
    [
      "Bestickter Hoodie",
      "Embroidered hoodie"
    ],
    [
      "Pixel Sportwagen",
      "Pixel Sports Car"
    ],
    [
      "Pixel Pinguin",
      "Pixel Penguin"
    ],
    [
      "Pixel Dackel",
      "Pixel Dachshund"
    ],
    [
      "Pixel Geist",
      "Pixel Ghost"
    ],
    [
      "Pixel Bär",
      "Pixel Bear"
    ]
  ]
};
// Weglot and Dawn can insert default-language sections after a variant change.
window.rs2UITranslations.pairs.push(
  ['Hauptnavigation', 'Main navigation'],
  ['Cap-Bestseller entdecken ↓', 'Explore bestselling caps ↓'],
  ['DEINE FAVORITEN', 'YOUR FAVORITES'],
  ['Kleine Pixel. Große Cap-Liebe.', 'Small pixels. Big cap energy.'],
  ['Alle Caps', 'All caps'],
  ['Versand (DE)', 'shipping (DE)'],
  ['Inkl. MwSt.', 'VAT included'],
  ['Versand gratis ab', 'Free shipping from'],
  ['Kostenloser Versand in Deutschland', 'Free shipping in Germany'],
  ['Versandkosten & Lieferung', 'Shipping costs & delivery'],
  ['Stickfarbe', 'Embroidery color'],
  ['Mehrfarbig', 'Multicolor'],
  ['Caps ansehen', 'Shop caps'],
  ['Bewertungen aus unserem Shop', 'Reviews from our shop'],
  ['Angenehm auf der Haut', 'Comfortable against the skin'],
  ['Materialdetails unten', 'Material details below'],
  ['– Materialdetails unten', '– Material details below'],
  ['Hochwertige Stickerei', 'Quality embroidery'],
  ['statt Print', 'instead of print'],
  ['& 30 Tage Rückgabe', '& 30-day returns'],
  ['Entfernen', 'Remove']
);
